import * as Types from '../../types';

import { gql } from '@apollo/client';
import { EntityRiskIndicatorFragmentDoc } from '../../components/RiskIndicator/RiskIndicator.generated';
import { AddressDisplayFragmentDoc } from '../../components/AddressDisplay/AddressDisplay.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEntityQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type GetEntityQuery = {
  __typename?: 'Query';
  entity?: {
    __typename?: 'Entity';
    id: any;
    name: string;
    risks: {
      __typename?: 'EntityRiskConnection';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
      edges: Array<{
        __typename?: 'EntityRiskEdge';
        node: {
          __typename?: 'EntityRisk';
          id: any;
          riskType: string;
          severity: string;
          description?: string | null;
        };
      }>;
    };
    addresses: {
      __typename?: 'AddressConnection';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
      edges: Array<{
        __typename?: 'AddressEdge';
        cursor: string;
        node: {
          __typename?: 'Address';
          createdAt?: any | null;
          address: string;
          entity?: {
            __typename?: 'Entity';
            id: any;
            name: string;
            risks: {
              __typename?: 'EntityRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'EntityRiskEdge';
                node: {
                  __typename?: 'EntityRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          } | null;
          risks: {
            __typename?: 'AddressRiskConnection';
            totalCount: number;
            pageInfo: {
              __typename?: 'PageInfo';
              hasNextPage: boolean;
              hasPreviousPage: boolean;
              startCursor?: string | null;
              endCursor?: string | null;
            };
            edges: Array<{
              __typename?: 'AddressRiskEdge';
              node: {
                __typename?: 'AddressRisk';
                id: any;
                riskType: string;
                severity: string;
                description?: string | null;
              };
            }>;
          };
        };
      }>;
    };
  } | null;
};

export const GetEntityDocument = gql`
  query GetEntity($id: UUID!) {
    entity(id: $id) {
      id
      name
      risks {
        ...EntityRiskIndicator
      }
      addresses(first: 100) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            ...AddressDisplay
            createdAt
          }
        }
      }
    }
  }
  ${EntityRiskIndicatorFragmentDoc}
  ${AddressDisplayFragmentDoc}
`;

/**
 * __useGetEntityQuery__
 *
 * To run a query within a React component, call `useGetEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEntityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEntityQuery,
    GetEntityQueryVariables
  > &
    (
      | { variables: GetEntityQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEntityQuery, GetEntityQueryVariables>(
    GetEntityDocument,
    options,
  );
}
export function useGetEntityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEntityQuery,
    GetEntityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEntityQuery, GetEntityQueryVariables>(
    GetEntityDocument,
    options,
  );
}
export function useGetEntitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEntityQuery, GetEntityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEntityQuery, GetEntityQueryVariables>(
    GetEntityDocument,
    options,
  );
}
export type GetEntityQueryHookResult = ReturnType<typeof useGetEntityQuery>;
export type GetEntityLazyQueryHookResult = ReturnType<
  typeof useGetEntityLazyQuery
>;
export type GetEntitySuspenseQueryHookResult = ReturnType<
  typeof useGetEntitySuspenseQuery
>;
export type GetEntityQueryResult = Apollo.QueryResult<
  GetEntityQuery,
  GetEntityQueryVariables
>;
